import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

const carsListCustomer = {
  api: (search, tag, vehicleName) => {
    const currentPageValue = currentPage()
    const searchQuery = search ? `search=${search}` : ''
    const tagQuery = tag ? `company_vehicle_tags__id__in=${tag}` : ''
    const vehicleNameQuery = vehicleName ? `vehicle__id__in=${vehicleName}` : ''
    const queryParams = [searchQuery, tagQuery, vehicleNameQuery]
      .filter(Boolean)
      .join('&')
    const url = `vehicles/companies/${currentPageValue}${
      queryParams ? `?${queryParams}` : ''
    }`

    return axiosFactory()
      .auth.get(url)
      .then((res) => res.data)
      .catch((error) => errorHandler(error))
  },
}

const carsListSummary = {
  api: (search, metrics) => {
    const searchQuery = search ? `search=${search}` : ''
    const metricsQuery = metrics ? `metrics__id__in=${metrics}` : ''
    const queryParams = [searchQuery, metricsQuery].filter(Boolean).join('&')

    return axiosFactory()
      .auth.get(
        `vehicles/companies/summaries/${queryParams ? `?${queryParams}` : ''}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const carCabins = {
  api: () => {
    return axiosFactory()
      .auth.get('vehicles/cabins/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const removeCar = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('vehicles/companies/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getACar = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('vehicles/companies/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const carStatus = {
  api: () => {
    return axiosFactory()
      .auth.get('vehicles/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const carOwnership = {
  api: () => {
    return axiosFactory()
      .auth.get('vehicles/ownerships/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const addCar = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('vehicles/companies/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editCar = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('vehicles/companies/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const patchCar = {
  api: (payload) => {
    return axiosFactory()
      .auth.patch('vehicles/companies/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const deviceAssignHistory = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('histories/company-vehicles/devices/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverAssign = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('vehicles/companies/' + payload.id + '/drivers/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const deviceAssign = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('vehicles/companies/' + payload.id + '/devices/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverAssignHistory = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('histories/company-vehicles/drivers/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getCost = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`vehicles/companies/${payload}/information/costs/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addCost = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('vehicles/companies/information/costs/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editCost = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(`vehicles/companies/${payload.id}/information/costs/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getInsurance = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`vehicles/companies/${payload}/information/insurances/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addInsurance = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('vehicles/companies/information/insurances/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editInsurance = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(
        `vehicles/companies/${payload.id}/information/insurances/`,
        payload
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

//

const getTechnical = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`vehicles/companies/${payload}/information/technicals/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addTechnical = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('vehicles/companies/information/technicals/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editTechnical = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(
        `vehicles/companies/${payload.id}/information/technicals/`,
        payload
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const addInsuranceNew = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('insurances/company-vehicles/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editInsuranceNew = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(`insurances/company-vehicles/${payload.id}/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getAInsuranceNew = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`insurances/company-vehicles/${payload}/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const removeInsurance = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('insurances/company-vehicles/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getInsuranceType = {
  api: () => {
    return axiosFactory()
      .auth.get(`insurances/vehicles/types/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const getInsuranceNew = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`insurances/company-vehicles/?company_vehicle=${payload}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addInsuranceTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('insurances/company-vehicles/transactions/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getInsuranceTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `insurances/company-vehicles/transactions/?company_vehicle_insurance=${payload}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const removeInsuranceTransaction = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('insurances/company-vehicles/transactions/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        // errorHandler(error)
      })
  },
}

export const getCarsTag = {
  api: () => {
    return axiosFactory()
      .auth.get(`vehicles/companies/tags/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

export const addTag = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('vehicles/companies/tags/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const downloadCarsList = {
  api: () => {
    return axiosFactory({ type: 'blob' })
      .auth.get(`exports/vehicles/companies/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export {
  carsListCustomer,
  removeCar,
  getACar,
  carStatus,
  carOwnership,
  carCabins,
  addCar,
  editCar,
  patchCar,
  driverAssign,
  deviceAssignHistory,
  driverAssignHistory,
  carsListSummary,
  getCost,
  addCost,
  editCost,
  getInsurance,
  addInsurance,
  editInsurance,
  getTechnical,
  addTechnical,
  editTechnical,
  addInsuranceNew,
  editInsuranceNew,
  getInsuranceType,
  getInsuranceNew,
  getAInsuranceNew,
  removeInsurance,
  addInsuranceTransaction,
  getInsuranceTransaction,
  removeInsuranceTransaction,
}
